// extracted by mini-css-extract-plugin
module.exports = {"inputText":"inputText_inputText__42c4P","inputMessage":"inputText_inputMessage__3jJ7n"};